










































































import {
  defineComponent,
  ref,
  computed,
  ComputedRef,
  reactive,
  nextTick,
} from "@vue/composition-api";

import store from "@/store";
import MeterReadingForm from "./MeterReadingForm.vue";
import {
  METER_READING_DATA_KEYS,
  MeterReadingComponentState,
  MeterReadingData,
} from "../state";
import Loading from "vue-loading-overlay";
import LoadingOverlay from "@/shared/components/LoadingOverlay/LoadingOverlay.vue";
import LoadingButton from "@/shared/components/LoadingButton/LoadingButton.vue";

export default defineComponent({
  name: "MeterReadings",
  props: {},
  components: {
    Loading,
    LoadingOverlay,
    LoadingButton,
    MeterReadingForm,
  },
  setup() {
    const isLoadingMeterReadings = ref(false);
    const { getMeterReadingData } = store.dispatch;
    const submitted = ref(false);
    const succeeded = ref(false);
    const isSubmitting = ref(false);
    const invalidReadings: string[] = reactive([]);
    const validateNow = ref(0);
    const allNewReadingValuesSet = computed(
      () =>
        !meterReadings?.value?.some(
          (meterReading) =>
            !meterReading[METER_READING_DATA_KEYS.READING_VALUE_NEW]
        )
    );

    const allReadingsValid = computed(() => {
      // need to add this detour of variable assignment as computed somehow doesn't udpate otherwise
      const allSet = allNewReadingValuesSet.value;
      return !invalidReadings?.length && allSet;
    });

    const storeMeterReadings: ComputedRef<
      MeterReadingComponentState["meterReadingData"]
    > = computed(() => store.getters.meterReadings);

    const meterReadings: ComputedRef<MeterReadingData[]> =
      computed(
        () =>
          Object.keys(storeMeterReadings.value)?.map(
            (meterReadingKey) => store.getters.meterReadings[meterReadingKey]
          ) ?? []
      ) ?? [];

    const addInvalidReading = (id: string) => {
      if (!invalidReadings.includes(id)) {
        invalidReadings.push(id);
      }
    };

    const removeInvalidReading = (id: string) => {
      if (id && invalidReadings.includes(id)) {
        invalidReadings.splice(invalidReadings.indexOf(id), 1);
      }
    };

    // Initialization logic with async setters and functions
    const initializeComponent = async () => {
      isLoadingMeterReadings.value = true;

      // @ts-ignore
      await getMeterReadingData();
      isLoadingMeterReadings.value = false;
    };

    const onSubmit = async () => {
      // Trigger validation and formatting in all MeterReadingForm components
      validateNow.value++;
      await nextTick();

      if (!allReadingsValid.value) {
        return;
      }

      submitted.value = false;
      succeeded.value = false;
      isSubmitting.value = true;
      // @ts-ignore
      const response = await store.dispatch.submitMeterReadingData();
      isSubmitting.value = false;
      submitted.value = true;
      succeeded.value = !!response?.data?.success;
    };

    initializeComponent();

    return {
      meterReadings,
      allReadingsValid,
      isLoadingMeterReadings,
      isSubmitting,
      submitted,
      succeeded,
      addInvalidReading,
      removeInvalidReading,
      validateNow,
      onSubmit,
    };
  },
});
